import { render } from "./login_main.vue?vue&type=template&id=720b7d22"
import script from "./login_main.vue?vue&type=script&lang=js"
export * from "./login_main.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__